import { queryOptions } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { EntityAppliedIn, EntityFieldType, EntityGroupListItem } from '@erp/shared';

/**
 * Prefixo comum das queries de campos personalizados. Invalidar
 * ['erp', 'entities'] também alcança as queries de grupos usadas nos
 * formulários de cliente/ticket (clients-queries usa o mesmo prefixo).
 */
export const ENTITIES_QUERY_KEY = ['erp', 'entities'] as const;

/** GET /entities — todos os grupos (com deskNames + fieldCount); as abas filtram client-side. */
export function entityGroupsOptions() {
  return queryOptions({
    queryKey: [...ENTITIES_QUERY_KEY, 'settings-list'] as const,
    queryFn: async ({ signal }) => {
      const res = await api<EntityGroupListItem[]>('/entities', { signal });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}

/** Abas da tela, na ordem da referência (Ticket | Recurso | Cliente). */
export const APPLIED_IN_TABS: EntityAppliedIn[] = ['ticket', 'equipment', 'client'];

export const APPLIED_IN_LABELS: Record<EntityAppliedIn, string> = {
  ticket: 'Ticket',
  equipment: 'Recurso',
  client: 'Cliente',
};

/** Labels pt-BR dos 9 tipos de campo do shared (EntityFieldTypeSchema). */
export const FIELD_TYPE_LABELS: Record<EntityFieldType, string> = {
  text: 'Texto',
  text_area: 'Área de texto',
  currency: 'Moeda',
  date: 'Data',
  phone: 'Telefone',
  email: 'E-mail',
  single_select: 'Lista de seleção',
  checkbox: 'Caixa de seleção',
  link: 'Link',
};

export const FIELD_TYPES = Object.keys(FIELD_TYPE_LABELS) as EntityFieldType[];
